'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCampaign = exports.fetchCampaign = exports.fetchCampaigns = undefined;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../utils/client');

var _justgiving = require('../../utils/justgiving');

var _params = require('../../utils/params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchCampaigns = exports.fetchCampaigns = function fetchCampaigns(_ref) {
  var _ref$ids = _ref.ids,
      ids = _ref$ids === undefined ? (0, _params.required)() : _ref$ids;

  return Promise.resolve().then(function () {
    return Array.isArray(ids) ? ids : ids.split(',');
  }).then(function (ids) {
    return Promise.all(ids.map(fetchCampaign));
  });
};

var fetchCampaign = exports.fetchCampaign = function fetchCampaign() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return _client.servicesAPI.get('/v1/justgiving/campaigns/' + id).then(function (response) {
    return response.data;
  });
};

var deserializeCampaign = exports.deserializeCampaign = function deserializeCampaign(campaign) {
  return {
    charities: campaign.charities,
    donateUrl: [(0, _justgiving.baseUrl)('link'), 'v1/campaign/donate/campaignGuid', campaign.campaignGuid].join('/'),
    eventId: campaign.eventId,
    getStartedUrl: (0, _justgiving.baseUrl)() + '/fundraising-page/creation?campaignGuid=' + campaign.campaignGuid,
    id: campaign.campaignGuid,
    name: campaign.title,
    image: (0, _justgiving.imageUrl)((0, _get2.default)(campaign, 'heroImage.imageName')),
    raised: campaign.donationSummary.totalAmount,
    raisedOffline: campaign.donationSummary.offlineAmount,
    slug: campaign.shortName,
    story: (0, _justgiving.parseText)(campaign.story),
    summary: campaign.summary,
    target: campaign.targetAmount,
    totalDonations: campaign.donationSummary.totalNumberOfDonations,
    url: (0, _justgiving.baseUrl)() + '/campaign/' + campaign.shortName
  };
};